var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DetailedSlotGeneric',{staticClass:"detailed-slot-vacation"},[_vm._v(" Отпуск "),_c('span',{staticClass:"detailed-slot-vacation__date"},[_vm._v(_vm._s(_vm.dates))])])}
var staticRenderFns = []

export { render, staticRenderFns }